import React, { useState, useEffect, useRef } from "react";
import "../../../../css/bs-stepper.css";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { IconSmartHome, IconUsers, IconCalendarEvent, IconPhoto, IconFileDescription, IconBuilding, IconPalette,IconSlideshow } from '@tabler/icons-react';
import "../../MyInvitations/Common/FormCss.css";
import { useAuth } from "../../../Context/store/context";
import { _get } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import globals from "../../../../globals";
import { fetchadmininfo } from "../../../Redux/Actions/AdmininfoAction";
import StepHeader from "../../MyInvitations/Common/Step-Header";
import ThemeCustomization from "../../MyInvitations/Common/Customization/ThemeCustomization";
import Save from "../../MyInvitations/Wedding/Save";
import FetchAndBindData from "../../MyInvitations/Wedding/BindData";
import TitleCustomizations from "../../MyInvitations/Common/TitleCustomizations/TitleCustomizations";
import About from "../common/About/About";
import Awards from "../common/Awards/Awards";
import GalleryParent from "../common/NewGallery/GalleryParent";
import ContactUs from "../common/ContactUs/Contactus";
import CustomPage from "../common/Custom Page/CustomPage";
import TemplateCustomization from "../../MyInvitations/Common/Theme Customization/ThemeCustomization";
import HomePage2 from "../common/Home Page/HomePage2";
import SaveData from "../../MyInvitations/Wedding/SaveData";
import Community from "../common/Community/Community";
import Subpeople from "../common/Subpeople/Subpeople";
import Brand from "../common/BrandLogos/Brand";
import Artical from "../common/Articles/Artical";
import Background from "../common/BackgroundImage/Background";



export default function WebsitePageForm() {
  const Navigate = useNavigate();
  const { categoryId, themeId, id } = useParams();
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const dispatch = useDispatch();
  const [deletedImages, setDeletedImages] = useState([]);

    const eventSections = [
   
    {
      title: "Home silders", subTitle: "", data: null, isValid: false, sectionname: "theme",
      icon: function () {
        return <IconSlideshow size={22} />
      }
    },
    {
      title: "Events Page", subTitle: "Awards and honours", data: null, isValid: false, sectionname: "events",
      icon: function () {
        return <IconCalendarEvent size={22} />
      }
    },
    {
      title: "Videos Page", subTitle: "landing page", data: null, isValid: false, sectionname: "invitation",
      icon: function () {
        return <IconSmartHome size={22} />
      }
    },
    {
      title: "Community Page", subTitle: "community page", data: null, isValid: false, sectionname: "community",
      icon: function () {
        return <IconSmartHome size={22} />
      }
    },
    {
      title: "Gallery", subTitle: "Memories", data: null, isValid: false, sectionname: "gallery",
      icon: function () {
        return <IconPhoto size={22} />
      }
    },
    {
      title: "People", subTitle: "People section", data: null, isValid: false, sectionname: "subpeople",
      icon: function () {
        return <IconPhoto size={22} />
      }
    },
    {
      title: "Brand Logos Pages", subTitle: "People section", data: null, isValid: false, sectionname: "brand",
      icon: function () {
        return <IconPhoto size={22} />
      }
    },
      {
      title: "Articles Pages", subTitle: "People section", data: null, isValid: false, sectionname: "articles",
      icon: function () {
        return <IconPhoto size={22} />
      }
    },
    {
      title: "Contact Us Page", subTitle: "Contact Details", data: null, isValid: false, sectionname: "people",
      icon: function () {
        return <IconUsers size={22} />
      }
    },
    {
      title: "News Page", subTitle: "About Me", data: null, isValid: false, sectionname: "couple",
      icon: function () {
        return <IconUsers size={22} />
      }
    },
    
    
    
    
  
    // // {
    // //   title: "Background Pages", subTitle: "People section", data: null, isValid: false, sectionname: "background",
    // //   icon: function () {
    // //     return <IconPhoto size={22} />
    // //   }
    // // },
    
  
   
    {
      title: "Theme Customization", subTitle: "colors and meta data", data: null, isValid: false, sectionname: "customization",
      icon: function () {
        return <IconPalette size={22} />
      }
    },
   
  ];


  const Titles = [
    {
        title:"Home Page",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: true,
        isValid: false,
        ref:null
    },
    {
        title:"About Page",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
    {
        title:"Awards Page",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
    {
        title:"Gallery",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
    {
        title:"Contact Us",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
    {
        title:"Custom Page",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
]


  const HomeSections = [
    {
        title:"Home Header",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: true,
        isValid: false,
        ref:null
    },
    {
        // title:"About Page",
        title:"Home Slider",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
    {
        title:"Records",
        sectionTitle:"",
        sectionSubTitle:"",
        navbarTitle:"",
        show: false,
        isValid: false,
        ref:null
    },
]
  const [sections, setSections] = useState([]);
  const [eventId, setEventId] = useState(0);
  const [eventCode, setEventCode] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const childRef = useRef();
  
  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.dashboard.title, globals.dashboard.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      if (id) {
        fetchandBindData(id);
      }
      else
        setSections(eventSections);
    }
  }, [userDetails, id]);

  const fetchandBindData = async (id) => {
    let result = await FetchAndBindData(id, eventSections);
    if (result) {
      setSections(result.sections);
      setEventId(result.eventId);
      setEventCode(result.eventCode);
    }
    else
      return Navigate("/invitations");
  }

  const handleSectionClick = (e, step) => {
    e.preventDefault();
    if (validateForm()) {
      let nextStep = currentStep + 1;
      while (nextStep < step) {
        if (sections[nextStep].isValid)
          nextStep++;
        else {
          let section = sections[nextStep];
          _showToast("Please provide information in " + section.title + " section", "warning");
          return;
        }
      }
      getAndUpdateData();
      setCurrentStep(step);
    } else {
      _showToast("Please provide information for all the required fileds before proceeding further", "warning");
    }
  };
  const insertDeletedImage = (imageKey) => {
    setDeletedImages(current => [...current, imageKey]);
  }
  const renderStep = () => {
    if (sections && sections.length > 0) {
      const section = sections[currentStep];
      console.log("Current Section Data:", section.data);
      switch (section.sectionname) {
      
        case "invitation":
          return (<HomePage2  ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} Titles={HomeSections}/>);
        case "couple":
          return (<About  ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "events":
          return (<Awards ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "community":
          return (<Community ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "subpeople":
          return (<Subpeople ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "gallery":
          return (<GalleryParent ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "people":
          return (<ContactUs ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "story":
          return (<CustomPage ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "brand":
          return (<Brand ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "articles":
          return (<Artical ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "background":
          return (<Background ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "customTitle":
          return (<TitleCustomizations ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} Titles={Titles}/>);
        case "theme":
          return (<ThemeCustomization  ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} save={saveHandler} imageDelete={insertDeletedImage} />);
        case "customization":
          return (<TemplateCustomization ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} save={saveHandler} imageDelete={insertDeletedImage} Titles={Titles}/>);
      
       
        }
    }
  };
  console.log("Current Section Data:", sections);

  const validateForm = () => {
    sections[currentStep].isValid = childRef?.current?.validate() ?? false;
    return sections[currentStep].isValid;
  }

  const getAndUpdateData = () => {
    const updatedSections = [...sections];
    updatedSections[currentStep]["data"] = childRef?.current?.getData() ?? null;
    setSections(updatedSections);
  }

  const saveHandler = async (e) => {
    e.preventDefault();
    console.log("saveHandler")
    if (validateForm()) {
      getAndUpdateData();
      showLoader();
      console.log("sections",sections)
      // debugger;
      await SaveData([...sections], themeId, categoryId, eventId, eventCode, deletedImages);

      
    }
    else {
      _showToast("Please provide information for all the required fields before proceeding further", "warning");
    }
  }

  const updateEventCount = () => {
    userDetails.eventCount = userDetails.eventCount + 1;
    dispatch(fetchadmininfo(userDetails));
  }

  return (
    <div className="content-wrapper container-xxl flex-grow-1 container-p-y  ">

      <div className="bs-stepper wizard-vertical wizard-numbered vertical mt-2">
        <div className="bs-stepper-header">
          {sections.map((section, index) => {
            const isActive = index === currentStep;
            let backgroundcolor = "text-gray";

            if (isActive) {
              backgroundcolor = "text-red";
            } else if (section.isValid) {
              backgroundcolor = "text-green";
            }
            return <StepHeader backgroundColor={backgroundcolor}
              Icon={section.icon}
              title={section.title}
              subTitle={section.subTitle}
              className={`step ${isActive ? "active" : ""}`}
              onClick={(e) => handleSectionClick(e, index)}
              key={index} />
          })}
        </div>
        <div className="bs-stepper-content">{renderStep()}</div>
      </div>
    </div>
  );
}
